export default __webpack_public_path__ + "images/orbits_dark.bf01f83c03819a0622c8f6ce0cfec9f4.png";